import { render, staticRenderFns } from "./payFeeDetail.vue?vue&type=template&id=a848b06a&scoped=true"
import script from "./payFeeDetail.vue?vue&type=script&lang=js"
export * from "./payFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./payFeeDetail.vue?vue&type=style&index=0&id=a848b06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a848b06a",
  null
  
)

export default component.exports